<template>
  <div class="wrapper-table">
    <table class="table table-striped">
      <thead>
        <tr>
          <th
            v-for="(header, headerIndex) in processedHeaders"
            :key="headerIndex"
            :class="header.thclass"
          >
            {{ header.text }}
          </th>
          <th v-if="actions" class="text-center actions-lg">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, itemIndex) in data" :key="itemIndex">
          <td
            v-for="(header, hIndex) in processedHeaders"
            :key="hIndex"
            :class="header.tdclass"
          >
            {{ item[header.property] || '-' }}
          </td>
          <td v-if="actions" class="text-center">
            <action-item :actions="actions" :item="item" />
          </td>
        </tr>
        <tr v-if="data.length === 0">
          <td :colspan="processedHeaders.length + 1">
            Nenhum item encontrado.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ActionItem from './ActionItem'
export default {
  props: ['headers', 'data', 'actions'],
  components: {
    ActionItem
  },
  computed: {
    processedHeaders() {
      let array = []

      this.headers.forEach(header => {
        if (header.property !== 'Id') {
          array.push(header)
        }
      })

      return array
    }
  }
}
</script>
